<template>
    <div class="d-flex justify-content-center">
        <div 
            v-if="loading" 
            class="spinner-border text-primary" 
            role="status" 
        />
        <div v-else-if="success" class="d-flex flex-column justify-content-center align-items-center gap-3 text-center fs-2">
            <div>
                <i class="bi bi-envelope-check text-success display-5" />
                <i class="bi bi-wind text-muted display-6" />
            </div>
            {{ $translate('report_bug_success_message', 'Tack för att du informerar oss om att något är fel.') }}
        </div>
        <div v-else class="w-100">
            <form 
                class="d-flex flex-column gap-4"
                enctype="multipart/form-data"
                novalidate
            >
                <div 
                    v-if="$validateText($translate('report_bug_text'))"
                    class="rich-text" 
                    v-html="$prismic.asHtml($translate('report_bug_text'))"    
                />
                <DynamicInput 
                    v-for="(input, key) in inputs" 
                    :key="key"
                    :input-id="input.id"
                    :is-custom-input="input.isCustomInput"
                    :is-textarea="input.isTextarea"
                    :input-key="input.key"
                    :label="input.label"
                    :type="input.type"
                    :error="showErrors && !input.validate(input.value)"
                    :error-message="input.errorMessage"
                    @on-user-input="updateInputValue"
                >
                    <div 
                        v-if="input.isCustomInput" 
                        class="form-attachment-btn form-control h-100 shadow-none py-3 cursor-pointer" 
                        :class="showErrors && !input.validate(input.value) ? 'border-danger' : ''"
                    >
                        <div class="d-flex flex-column align-items-center justify-content-center text-secondary">
                            <i class="bi bi-cloud-arrow-up text-secondary fs-1" />
                            <span v-if="input.value && input.value.length" class="text-dark">
                                {{ input.value[0].name }}
                            </span>
                        </div>
                        <input
                            :id="input.id"
                            :name="input.key"
                            type="file" 
                            class="form-attachment-btn-label prevent-autofill-background"
                            placeholder=" "
                            @input="(e) => updateInputValue(e.currentTarget.files, key)"
                        > 
                    </div>  
                </DynamicInput> 
                <button 
                    class="fw-bold btn btn-dark btn-sm rounded-pill" 
                    @click.prevent="onSubmit"
                >
                    {{ $translate('report_bug_submit_button_text', 'Rapportera felet') }}
                </button>
                <div v-show="submitError" class="text-danger bg-soft-danger bg-gradient p-1 px-2 text-center">
                    {{ $translate('report_bug_general_error_message', 'Obs, något gick fel.') }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { uniqueId } from 'lodash';
import DynamicInput from '@/components/DynamicInput.vue';
export default {
    components: {
        DynamicInput
    },
    data() {
        return {
            loading: false,
            success: false,
            submitError: false,
            showErrors: false,
            currentUrl: process.env.APP_URL + this.$route.path,
            formEndpoint: process.env.FORMSPREE_URL,
            inputs: {
                email: {
                    id: uniqueId('email-'),
                    key: 'email',
                    value: null,
                    label: this.$translate('email_address', 'E-post'),
                    type: 'email',
                    errorMessage: '',
                    validate: () => true
                },
                message: {
                    isTextarea: true,
                    id: uniqueId('message-'),
                    key: 'message',
                    value: null,
                    label: this.$translate('report_bug_describe_bug_label', 'Beskriv felet *'),
                    type: 'textarea',
                    errorMessage: this.$translate('report_bug_describe_bug_error', 'Beskriv felet så detaljerat som möjligt.'),
                    validate: (input) => Boolean(input)
                },
                attachment: {
                    isCustomInput: true,
                    id: uniqueId('attachment-'),
                    key: 'attachment',
                    value: null,
                    type: 'file',
                    label: this.$translate('report_bug_attach_file_label', 'Bifoga fil'),
                    errorMessage: this.$translate('report_bug_attach_file_error', 'Bifogad fil måste vara en bild eller skärminspelning.'),
                    validate: (input) => {
                        if (input === null || !input.length) {
                            return true;
                        }
                        return input[0].type.includes('image') || input[0].type.includes('video');
                    }
                },
            }
        };
    },
    computed: {
        payload() {
            const data = new FormData();
            data.append('source', this.currentUrl);
            data.append('subject', 'Report Bug');
            
            Object.entries(this.inputs).forEach(([key, input]) => {
                if (input.value !== null) {
                    return key === 'attachment' 
                        ? data.append(key, input.value[0])
                        : data.append(key, input.value);
                }
            });

            return data;
        }
    },
    methods: {
        updateInputValue(value, key) {
            return this.inputs[key].value = value;
        },
        validateInputFields() {
            return Object.values(this.inputs).some(input => {
                return !input.validate(input.value);
            });
        },
        onSubmit() {
            this.submitError = false;
            this.success = false;
            if (this.validateInputFields()) {
                this.showErrors = true;
                return;
            }

            this.loading = true;

            this.$axios
                .post(this.formEndpoint, this.payload)
                .then(() => {
                    this.success = true;
                })
                .catch(() => {
                    this.showErrors = false;
                    this.submitError = true;
                })
                .then(() => {
                    this.loading = false;
                });
        },
    }};
</script>